class CardsSliderBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.slides = [...block.children];
    this.init();
    this.scrollAim = 0;
    this.scrollFactor = 15;
    this.scrollTime = 0;
    this.slidesPerView = +block.dataset.slidesPerView;

    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.scroll = this.scroll.bind(this);
  }

  init() {
    this.container = document.createElement('div');
    this.container.classList.add('sldr-container');

    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('sldr-wrapper');

    this.slides.forEach((slide) => {
      slide.classList.add('sldr-slide');
      this.wrapper.appendChild(slide);
    });

    this.container.appendChild(this.wrapper);

    this.block.appendChild(this.container);

    this.nav = document.createElement('div');
    this.nav.classList.add('slider__slider-nav');

    this.navButtonPrev = document.createElement('button');
    this.navButtonPrev.classList.add('slider__slider-nav-button');
    this.navButtonPrev.classList.add('slider__slider-nav-button--prev');
    this.navButtonPrev.setAttribute('aria-label', 'Previous');

    this.navArrowLeft = document.createElement('i');
    this.navArrowLeft.classList.add('icon-arrow-2-left');

    this.navButtonPrev.appendChild(this.navArrowLeft);

    this.navButtonNext = document.createElement('button');
    this.navButtonNext.classList.add('slider__slider-nav-button');
    this.navButtonNext.classList.add('slider__slider-nav-button--next');
    this.navButtonNext.setAttribute('aria-label', 'Next');

    this.navArrowRight = document.createElement('i');
    this.navArrowRight.classList.add('icon-arrow-2-right');

    this.navButtonNext.appendChild(this.navArrowRight);

    this.nav.appendChild(this.navButtonPrev);
    this.nav.appendChild(this.navButtonNext);

    this.block.appendChild(this.nav);

    // Bind drag
    this.wrapper.addEventListener('mousedown', (e) => this.onMouseDown(e));

    // Bind nav
    this.navButtonPrev.addEventListener('click', () => this.prev());
    this.navButtonNext.addEventListener('click', () => this.next());

    setTimeout(() => this.toggleNav());

    this.wrapper.addEventListener('scroll', () => this.toggleNav());

    // Disable dragging
    this.wrapper.querySelectorAll('a, img').forEach((el) => el.setAttribute('draggable', 'false'));

    // Fix fast-tabs bug where nav arrows are not displayed
    window.addEventListener('fast-tabs', () => this.toggleNav());
    window.addEventListener('resize', () => this.toggleNav());
  }

  prev() {
    this.initialScroll = this.wrapper.scrollLeft;
    this.scrollAim = this.normalize(this.wrapper.scrollLeft - this.slides[0].offsetWidth + 24);
    this.scrollTime = Date.now();
    requestAnimationFrame(this.scroll);
  }

  next() {
    this.initialScroll = this.wrapper.scrollLeft;
    this.scrollAim = this.normalize(this.wrapper.scrollLeft + this.slides[0].offsetWidth + 24);
    this.scrollTime = Date.now();
    requestAnimationFrame(this.scroll);
  }

  onMouseDown(e) {
    this.dragStart = e.clientX;
    this.initialScroll = this.wrapper.scrollLeft;
    this.scrollAim = this.initialScroll;

    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('mouseup', this.onMouseUp);
  }

  onMouseMove(e) {
    this.wrapper.scrollLeft = this.normalize(this.initialScroll + this.dragStart - e.clientX);

    if (Math.abs(this.wrapper.scrollLeft - this.initialScroll) > 2) {
      this.wrapper.classList.add('sliding');
    }
  }

  onMouseUp(e) {
    this.wrapper.classList.remove('sliding');
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
  }

  scroll() {
    const speed = 900;
    const dx = Math.abs(this.wrapper.scrollLeft - this.scrollAim);
    const dt = Math.max(0, this.scrollTime + speed - Date.now());
    const p = 1 - dt / speed;
    const t = p * p;
    const x = t * dx;

    if (this.scrollAim > this.wrapper.scrollLeft) {
      this.wrapper.scrollLeft = Math.min(this.scrollAim, this.normalize(this.wrapper.scrollLeft + x));
    } else if (this.scrollAim < this.wrapper.scrollLeft) {
      this.wrapper.scrollLeft = Math.max(this.scrollAim, this.normalize(this.wrapper.scrollLeft - x));
    }

    if (dx > 1) {
      requestAnimationFrame(this.scroll);
    }
  }

  toggleNav() {
    const d = Math.abs(this.wrapper.scrollWidth - this.wrapper.scrollLeft - this.wrapper.offsetWidth);

    if (this.wrapper.scrollLeft < 2) {
      this.navButtonPrev.classList.add('slider__slider-nav-button--disabled');
    } else {
      this.navButtonPrev.classList.remove('slider__slider-nav-button--disabled');
    }

    if (d < 2) {
      this.navButtonNext.classList.add('slider__slider-nav-button--disabled');
    } else {
      this.navButtonNext.classList.remove('slider__slider-nav-button--disabled');
    }
  }

  normalize(value) {
    return Math.min(this.wrapper.scrollWidth - this.wrapper.offsetWidth, Math.max(0, value));
  }

  ease(distance, duration = 400) {}
}

// Initialize each block on page load (front end)
if (!window.acf) {
  document.querySelectorAll('.cards-slider').forEach((block) => {
    new CardsSliderBlock(block);
  });

  // Initialize password protected pages
  window.addEventListener('init', () => {
    document.querySelectorAll('.cards-slider').forEach((block) => {
      new CardsSliderBlock(block);
    });
  });
}